<iframe *ngIf="url" [src]="url" frameborder="0" scrolling="no" #sisenseIFrame>
  <p>Browser does not Support iFrames</p>
</iframe>
